import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { UseAuthContext } from '../../context/AuthContext';
import { getErrorMsg } from '../utils/commonUtil';

export default function SearchCity({ setResultData }) {
    const { t } = useTranslation();
    const { token } = UseAuthContext();
    const [query, setQuery] = useState('');

    useEffect(() => {
        if (query.length < 3) {
            setResultData({ data: null, loading: false, msg: '' });
            return;
        }

        const controller = new AbortController();
        let active = true;
        setResultData({ data: null, loading: true, msg: '' });

        axios.get('/api/v1/postal-city/autocomplete', {
            params: { q: query, numberOfSuggestions: 50 },
            headers: { Authorization: `Bearer ${token}` },
            signal: controller.signal
        }).then(res => {
            if (!active) {
                return;
            }
            if (!Array.isArray(res.data)) {
                throw new Error('Invalid postal city autocomplete response');
            }
            setResultData({ data: res.data, loading: false, msg: '' });
        }).catch(err => {
            if (active) {
                setResultData({ data: null, loading: false, msg: getErrorMsg(err.message) });
            }
        });

        return () => {
            active = false;
            controller.abort();
        };
    }, [query, token, setResultData]);

    return (
        <div className="mt-2 text-sm">
            <div className="form-group">
                <label htmlFor="postal-city-query">{t('search.city_query')}</label>
                <input
                    type="text"
                    className="form-control form-control-sm"
                    id="postal-city-query"
                    value={query}
                    onChange={event => setQuery(event.target.value)}
                    aria-describedby="postal-city-help"
                    autoComplete="off"
                />
                <small id="postal-city-help" className="form-text text-muted">{t('search.city_hint')}</small>
            </div>
        </div>
    );
}

export function SearchCityResultTable({ resultData }) {
    const { t } = useTranslation();
    const { data, loading, msg } = resultData;

    return (
        <div className="card-content" aria-busy={loading}>
            <div role={msg ? 'alert' : 'status'} aria-live="polite" className="text-center py-3">
                {loading ? t('result.loading') : msg || (data?.length === 0 ? t('result.no_data') : !data ? t('search.city_hint') : '')}
            </div>
            <div className="table-responsive">
                <table className="table table-striped table-bordered table-sm">
                    <caption className="sr-only">{t('search.search_city')}</caption>
                    <thead>
                        <tr>
                            <th scope="col">{t('search.post_code')}</th>
                            <th scope="col">{t('search.city')}</th>
                            <th scope="col">{t('search.city_suggestion')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map((suggestion) => (
                            <tr key={`${suggestion.data.postalCode}-${suggestion.data.city}`}>
                                <td>{suggestion.data.postalCode}</td>
                                <td>{suggestion.data.city}</td>
                                <td>{suggestion.text}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
